import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, memo } from 'react';
const SvgSortUp = (props, ref) => (_jsx("svg", Object.assign({}, props, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 320 512", ref: ref }, { children: _jsx("path", { d: "M32.032 224h255.93c28.425 0 42.767-34.488 22.627-54.627l-127.962-128c-12.496-12.496-32.758-12.497-45.255 0l-127.968 128C-10.695 189.472 3.55 224 32.032 224zM160 64l128 128H32L160 64z" }, void 0) }), void 0));
const ForwardRef = forwardRef(SvgSortUp);
const Memo = memo(ForwardRef);
export default Memo;
//# sourceMappingURL=SortUp.js.map